import axios from "axios";
import setAuthToken from "../auth/aut-headers";


import {BASE_API_URL} from '../base_url'

const API_URL = BASE_API_URL + "/api/imported";




class ImportedMailService {

 


  getimportedmails(query:string) {
    return axios
      .get(API_URL + "/list?" + query, {
        params:{
           
        }
      })
      .then(response => {
        return response.data;
      });
  }


    
  getlookups() {
    return axios
      .get(API_URL + "/importedmail-lookup" , {
        params:{
           
        }
      })
      .then(response => {
        return response;
      });
  }

  addimport(data:any) {
    //console.log(query)
    return axios
      .post(API_URL, data)
      .then(response => {
        return response.data;
      });
  }


 

}

export default new ImportedMailService();